export const buildPortailLink = (
    href: string,
    options?: { queryParams?: Record<string, string>; fragment?: string }
) => {
    const url = new URL(href)

    if (options?.queryParams) {
        Object.entries(options.queryParams).forEach(([key, value]) => {
            url.searchParams.append(key, value)
        })
    }

    if (options?.fragment) {
        url.hash = options.fragment
    }

    return url.toString()
}
